import React from 'react'

const renderMark = (props, editor, next) => {
	const { children, mark } = props

	switch (mark.type) {
		case 'bold':
			return <strong>{children}</strong>
		case 'code':
			return <code>{children}</code>
		case 'italic':
			return <em>{children}</em>
		case 'strikethrough':
			return <del>{children}</del>
		case 'important':
			return <span className="o-important">{children}</span>
		default:
			return next()
	}
}

export default renderMark
